import { render, staticRenderFns } from "./CreditsModalCardInfo.vue?vue&type=template&id=e6f08458&scoped=true&"
import script from "./CreditsModalCardInfo.vue?vue&type=script&lang=js&"
export * from "./CreditsModalCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./CreditsModalCardInfo.vue?vue&type=style&index=0&id=e6f08458&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f08458",
  null
  
)

export default component.exports